module.exports = __webpack_public_path__ + "static/ai-decisioning-e6e2b26135071db8cf728c6f2d8d4b00.svg";